<template>
  <div class="main-wrapper">
    <el-form :inline="true" :model="formInline">
      <el-form-item label="时间：从">
        <el-date-picker v-model="formInline.dateFrom" type="date" placeholder="选择开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="formInline.dateTo" type="date" placeholder="选择结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="formInline.keyword" placeholder="关键字"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="btnSearchClick">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="items" style="width: 100%">
      <el-table-column width="100" label="Id">
        <template #default="scope">
          <el-link :underline="false" type="primary" :href="`/home/#/error?logId=${scope.row.id}`" target="_blank">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="createdDate" width="180" label="日期"></el-table-column>
      <el-table-column label="错误摘要">
        <template #default="scope">
          <span v-html="scope.row.summary"></span>
        </template>
      </el-table-column>
      <el-table-column label="错误消息">
        <template #default="scope">
          <span v-html="scope.row.message"></span>
        </template>
      </el-table-column>
    </el-table>

    <el-row style="margin: 10px">
      <el-col :span="24" align="center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="formInline.currentPage"
          :page-size="formInline.limit"
          layout="total, prev, pager, next, jumper"
          :total="count"
        ></el-pagination>
      </el-col>
    </el-row>

    <el-row>
      <el-divider></el-divider>
      <div style="height: 10px"></div>

      <el-button type="primary" @click="btnDeleteClick">清空日志</el-button>
    </el-row>
  </div>
</template>

<script lang="ts">
import { IErrorLog } from '@/types/models';
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/logsError';

interface IForm {
  dateFrom: string;
  dateTo: string;
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  items: IErrorLog[];
  count: number;
  formInline: IForm;
}

export default defineComponent({
  data() {
    return {
      items: [],
      count: 0,
      formInline: {
        dateFrom: '',
        dateTo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: 30,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
      });
    },

    apiDelete() {
      api.delete((res) => {
        if (!res) return;

        this.items = [];
        this.count = 0;
      });
    },

    btnDeleteClick() {
      utils.alertDelete(
        {
          title: '清空系统错误日志',
          text: '此操作将会清空系统错误日志，确定吗？',
          button: '清 空',
        },
        () => {
          this.apiDelete();
        },
      );
    },

    btnLogView(logId: number) {
      utils.pageOpen('error', {
        logId,
      });
    },

    btnSearchClick() {
      this.formInline.currentPage = 1;
      this.formInline.offset = 0;
      this.formInline.limit = 30;

      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.items = res.items;
        this.count = res.count;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
